import React, { useState } from 'react';
import axios from 'axios';
import ConfirmDialog from '../../../shared/ConfirmDialog';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import DateInput from '../../../shared/DateInput';
import { todayInTenant } from '../../../shared/tenantClock';
import { useErrorToast, useDismissError } from '../../../shared/ErrorToastContext';

// Pull Emails on an Entity's page: logs this record's emails from the
// signed-in staff member's own mailbox, from the chosen date to today
// (myAccountController.pullEntityEmails). Mounted only while open, so the
// date and result reset on every fresh open.
function oneMonthBack(ymd) {
  const [y, m, d] = ymd.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 2, 1));
  const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
  date.setUTCDate(Math.min(d, lastDay));
  return date.toISOString().slice(0, 10);
}

function PullEmailsDialog({ entityId, onOpenChange, onPulled }) {
  const today = todayInTenant();
  const [since, setSince] = useState(() => oneMonthBack(today));
  const [pulling, setPulling] = useState(false);
  const [result, setResult] = useState(null);
  const showError = useErrorToast();
  const dismissError = useDismissError();

  const pull = async () => {
    setPulling(true);
    try {
      const res = await axios.post('/api/my-account/mailbox/pull-entity', { commercial_entity_id: entityId, since });
      setResult(res.data.message);
      dismissError();
      if (res.data.logged) onPulled();
    } catch (err) {
      showError(err, 'Pull failed');
    }
    setPulling(false);
  };

  return (
    <ConfirmDialog
      open
      onOpenChange={(next) => { if (!pulling) onOpenChange(next); }}
      title="Pull Emails"
      description="Logs this record's emails from your own mailbox, from the date below to today. Your mailbox's History start date stays as it is."
      footer={result ? (
        <div style={{ display: 'flex', gap: 8 }}>
          <SaveButton type="button" onClick={() => onOpenChange(false)}>Close</SaveButton>
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 8 }}>
          <CancelButton onClick={() => onOpenChange(false)} disabled={pulling} />
          <SaveButton type="button" onClick={pull} loading={pulling} disabled={!since}>
            {pulling ? 'Pulling...' : 'Pull Emails'}
          </SaveButton>
        </div>
      )}
    >
      {result ? (
        <p style={{ margin: 0, fontSize: 14 }}>{result}</p>
      ) : (
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#5a6b85', marginBottom: 4 }}>From</label>
          <DateInput value={since} onChange={(e) => setSince(e.target.value)} max={today} disabled={pulling} />
        </div>
      )}
    </ConfirmDialog>
  );
}

export default PullEmailsDialog;
